// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'train';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 1.11v4.688m-2.59 6.644v-1.595a.576.576 0 0 1 .575-.575h4.03a.575.575 0 0 1 .576.575v1.595m3.103-5.974V3.454a2.35 2.35 0 0 0-2.345-2.345H5.651a2.351 2.351 0 0 0-2.345 2.345v3.014m1.074 7.743-1.54 2.68m10.78-2.68 1.54 2.68' />
    <path d='M14.694 11.492a.824.824 0 0 1-.67.81 19.28 19.28 0 0 1-5.024.53 19.278 19.278 0 0 1-5.03-.53.83.83 0 0 1-.664-.81V6.468A26.425 26.425 0 0 1 9 5.798c1.916.016 3.826.24 5.694.67zM5.283 8.448H3.306m11.388 0h-1.976' />
  </g>
);

export const viewBox = '0 0 18 18';
